
import { Shimmer } from "@/components/ui/shimmer";

export const GridLoadingState = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[1, 2, 3].map((i) => (
        <div key={i} className="border rounded-lg overflow-hidden">
          <Shimmer className="w-full h-48" />
          <div className="p-4 space-y-4">
            <Shimmer className="h-6 w-3/4" />
            <Shimmer className="h-4 w-1/2" />
            <div className="space-y-2">
              <Shimmer className="h-4 w-full" />
              <Shimmer className="h-4 w-2/3" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
